import { Link } from '@inertiajs/react';
import styles from './footer.module.css';

export function Footer() {
  return (
    <div className={styles.root}>
      <div>
        In partnership with{' '}
        <a href="https://imawakatta.com" target="_blank" rel="noopener">
          ImaWakatta
        </a>
      </div>
      <div className={styles.links}>
        <Link className={styles.link} href="/terms/" prefetch>
          Terms
        </Link>
        <Link className={styles.link} href="/privacy/" prefetch>
          Privacy
        </Link>
      </div>
    </div>
  );
}
